<div class="header-root">
  <div class="header-topbar header-topbar--row">

    <!-- LEFT : toggle + breadcrumb -->
    <div class="header-left">
<!-- <app-ui-button
  type="button"
  class="sidebar-toggle-btn"
  iconOnly="menu"
  ariaLabel="Toggle sidebar"
  (clicked)="emitToggle()"
></app-ui-button> -->

      <nav class="header-breadcrumb" aria-label="Fil d'Ariane">
        <span class="breadcrumb-root">SGBP</span>
        <!-- <mat-icon class="breadcrumb-sep">chevron_right</mat-icon> -->
        <span class="breadcrumb-current">{{ pageTitle }}</span>
      </nav>
    </div>

    <!-- RIGHT : actions + profil -->
    <div class="header-right">

      <!-- Notifications -->
      <app-ui-button
        type="button"
        class="header-action-btn"
        iconOnly="notifications_none"
        ariaLabel="Notifications"
      ></app-ui-button>

      <!-- Séparateur -->
      <div class="header-divider"></div>

      <!-- Menu profil -->
      <ProfileMenu />
    </div>

  </div>
</div>